module.exports = __webpack_public_path__ + "static/media/add-to-cart.7cab8d40.svg";